// extracted by mini-css-extract-plugin
export default {"dragHandle":"styles_dragHandle__FEX3A","dragBtn":"styles_dragBtn__7U4Qu","emptyPlaceholder":"styles_emptyPlaceholder__Kq8RY"};